import {
  BadgeColorEnum,
  BadgeShapeEnum,
  BadgeSizeEnum,
} from 'src/editor/shared/ui-lib/shared/badge-consts'

export const getBadgeDropdownCirlceColors = (color: BadgeColorEnum) => {
  const colors = {
    [BadgeColorEnum.Gray]: '[&>path]:stroke-gray-150',
    [BadgeColorEnum.Primary]: '[&>path]:stroke-primary-200',
    [BadgeColorEnum.Blue]: '[&>path]:stroke-textLink ',
  }
  return colors[color]
}

export const getSizeClasses = (size: BadgeSizeEnum) => {
  const sizes = {
    [BadgeSizeEnum.Small]: 'px-1.5 py-0.5 text-S leading-4',
    [BadgeSizeEnum.Medium]: 'px-2.5 py-1.5 text-S leading-4',
    [BadgeSizeEnum.Large]: 'px-3 py-2 text-M',
  }
  return sizes[size]
}

export const getShapeClasses = (shape: BadgeShapeEnum) => {
  const shapes = {
    [BadgeShapeEnum.Fill]: 'rounded-full',
    [BadgeShapeEnum.Rounded]: 'rounded-md',
  }
  return shapes[shape]
}

export const getColorClasses = (color: BadgeColorEnum) => {
  const colors = {
    [BadgeColorEnum.Gray]: 'bg-tagSoftGrayBg text-tagSoftGrayText',
    [BadgeColorEnum.Primary]: 'bg-tagSoftPrimaryBg text-tagSoftPrimaryText',
    [BadgeColorEnum.Blue]: 'bg-btnTertiary stroke-textLink',
  }
  return colors[color]
}

export const getCircleColorClasses = (color: BadgeColorEnum) => {
  const colors = {
    [BadgeColorEnum.Gray]: 'bg-gray-500',
    [BadgeColorEnum.Primary]: 'bg-primary-600',
    [BadgeColorEnum.Blue]: 'stroke-textLink',
  }
  return colors[color]
}

export const getCloseButtonClasses = (color: BadgeColorEnum) => {
  const colors = {
    [BadgeColorEnum.Gray]:
      '[&>path:first-child]:fill-gray-150 [&>path:last-child]:fill-iconSecondary',
    [BadgeColorEnum.Primary]:
      '[&>path:first-child]:fill-primary-200 [&>path:last-child]:fill-tagSoftPrimaryIcon',
    [BadgeColorEnum.Blue]:
      '[&>path:first-child]:fill-textLink [&>path:last-child]:fill-textLinkHover',
  }
  return colors[color]
}
